<template>
    <div>
        <kgr-optgroup-select
            :value="value"
            :optGroups="optGroups"
            :display="display"
            :loading="loading"
            :no-null-option="false"
            :label="label"
            :disabled="false"
            @post-input="onInput"
        />
    </div>
</template>

<script>
import GenericOptgroupSelect from './GenericOptgroupSelect.vue';
import InvoiceRecipientRepository from '../../../../js/repository/InvoiceRecipientRepository.js';

export default {
    components: {
        'kgr-optgroup-select': GenericOptgroupSelect,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        value: {
            type: Object,
            required: false,
        },
        display: {
            type: String,
            required: false,
            default: 'name',
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            optGroups: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('Rechnungsempfänger');
        },
    },
    created() {
        this.loadInvoiceRecipients();
    },
    methods: {
        loadInvoiceRecipients() {
            InvoiceRecipientRepository.findByChild(this.childId).then(
                (recipients) => {
                    this.loading = false;
                    const parents = recipients.filter(r => r.type === 'parent');
                    const costUnits = recipients.filter(r => r.type === 'cost-unit');
                    this.optGroups = [
                        {
                            label: this.$t('Rechnungsempfänger'),
                            options: parents,
                        },
                        {
                            label: this.$t('Zusätzliche Rechnungsempfänger'),
                            options: costUnits,
                        },
                    ];
                }
            ).catch(
                () => {
                    this.loading = false;
                    this.$notify.error('error.loadingData');
                }
            )
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    },
}
</script>
